import React, {useState, useEffect} from "react";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";
import { Translation } from "./Translation";
import Checkbox from "@amzn/meridian/checkbox";

export const ScrubTable = ({dispatch, selectiveMarkingEnabled, headers, contents, identifier}) => {
    const [checkedRows, setCheckedRows] = useState([]);

    useEffect(() => {
        dispatch({
            type : "SET_SELECTED",
            data : checkedRows
        })
    }, [checkedRows]);

    /**
     * Check if all rows are checked
     * - If checkedRows.length is 0, then false
     * - Check shipment, and check if it is present in the list
     */
    const areAllRowsChecked = (contents) => {
        if (checkedRows.length === 0) {
            return false;
        }

        for (let index in contents) {
            let shipment = contents[index];

            if (shipment.IS_TERMINAL_SCAN) {
                continue;
            }
            if (!checkedRows.includes(shipment[identifier])) {
                return false;
            }
        }

        return true;
    }

    /**
     * Check all filtered rows
     */
    const checkAllRows = (event) => {
        setCheckedRows(event ? contents
            .filter(shipment => !shipment.IS_TERMINAL_SCAN)
            .map(shipment => shipment[identifier]): []);
    }

    /**
     * Check if this row is selected
     */
    const isChecked = (shipmentId) => {
        return checkedRows.includes(shipmentId) === true;
    }

    /**
     * Select row
     */
    const checkRow = (shipmentId) => {
        checkedRows.includes(shipmentId) === true
            ? setCheckedRows(old => old.filter(row => row !== shipmentId))
            : setCheckedRows(old => [...old, shipmentId]);
    }

    return (
        <div style={{overflowX: "auto", maxWidth: "100%" }} >
            <Table headerRows={1} spacing="small">
                <TableRow>
                    {selectiveMarkingEnabled ?
                        <TableCell>
                            <Checkbox checked={areAllRowsChecked(contents)} onChange={(e) => checkAllRows(e)}/>
                        </TableCell>: null}

                    {headers.map(([name, value]) => (
                        <TableCell key={name} >
                            <Translation stringId={value.stringId} />
                        </TableCell>
                    ))}
                </TableRow>
                {
                    contents.map(shipment => (
                        <TableRow  backgroundColor={shipment.IS_TERMINAL_SCAN ? "secondary" : "primary"} key={shipment[identifier]} >
                            {(selectiveMarkingEnabled) ?
                                <TableCell>
                                    <Checkbox
                                        disabled={shipment.IS_TERMINAL_SCAN}
                                        checked={isChecked(shipment[identifier])}
                                        onChange={(e) => checkRow(shipment[identifier])}/>
                                </TableCell>: null}
                            {
                                headers.map(([name, value]) => (
                                    <TableCell key={name} >{shipment[name]}</TableCell>
                                ))
                            }
                        </TableRow>
                    ))
                }
            </Table>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/scrub/ScrubTable.js